var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('List',{attrs:{"loading":_vm.loading,"data":_vm.data,"error":_vm.error},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('div',{key:item.id,staticClass:"linkItem"},[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_vm._v(_vm._s(item.name))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }